import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const CellNotOverflowedStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "cell-not-overflow",
})`
  span {
    overflow: unset !important;
  }
`;
